
import ram from "../../assets/img/aboutus/ramk.png";
import rajini from "../../assets/img/aboutus/rajnikanth.png";
import jayk from "../../assets/img/aboutus/jayk.jpg";
import jagan from "../../assets/img/aboutus/jagan.jpg";
import amar from "../../assets/img/aboutus/amar.png";

export  const images = { ram, jayk, rajini, amar, jagan };

export interface TeamMember {
  id: number;
  name: string;
  role: string;
  image: keyof typeof images;
  desc: string;
  links: {
    email: string;
    linkedin: string;
    twitter: string;
  };
}